'use strict';
// import jQuery from 'jquery';

var throttle = require('lodash.throttle');


export default class Header {
  constructor() {

    var hamburger = document.querySelector('.js-header__mobile-menu');
    var header = document.querySelector('.js-header');
    var body = document.querySelector('body');

    if(hamburger){
        hamburger.addEventListener('click',function(){
          hamburger.classList.toggle('-is-active');
          header.classList.toggle('-is-active');
          body.classList.toggle('-is-active');
        })
      }

    const $scrollTop = $('.scroll-to-top')

    var checkIfBottom = function(){
      if (window.scrollY >=  200) {
           // you're at the bottom of the page
           $scrollTop.removeClass('-hide');
           $scrollTop.addClass('-show');

       } else {
         $scrollTop.addClass('-hide');
         $scrollTop.removeClass('-show');

       }
    }

    checkIfBottom();

        const stickyHeader= () => {

          const heightHeader = $('.js-header').height();

           if ($(window).scrollTop() >= 2 ) {
             $('.js-header').addClass('-sticky');
           } else {
             $('.js-header').removeClass('-sticky');
           }

           var scrollTop = $(window).scrollTop();
           var speed = scrollTop/2000;
           if(speed < 0.5) {
             speed = 0.5;
           } else if ( speed > 1 ){
             speed = 1;

           }


           $scrollTop.on('click', function() {
              TweenLite.to(window, speed, {scrollTo: speed, ease:Power2.easeOut});
           })


           checkIfBottom();

        }

    $(window).on('scroll', throttle(stickyHeader, 25));
    stickyHeader();


    var dropdownBtn = $('.js-dropdown-btn');
    dropdownBtn.on('click', function(e){
      $(this).parents('.js-dropdown').addClass('active');
        $(this).attr("aria-expanded","true");


    })

    dropdownBtn.on('focus', function(e){
      $(this).parents('.js-dropdown').addClass('active');
      $(this).parents('.js-dropdown').find('ul>li>a').attr('tabindex','-1');
      $(this).attr("aria-expanded","true");
    })

    $('.js-dropdown').on('blur', function(e){
      $(this).parents('.js-dropdown').removeClass('active');
      $(this).attr("aria-expanded","true");
    })

    // $('.js-dropdown--secondary li:last-child a').on('blur', function(e){
    //   $(this).parents('.js-dropdown').removeClass('active');
    // })

    $('.js-dropdown--secondary a').on('keydown',function(event){
      if (this !== event.target) return;
      var e = event.which || event.keyCode;
      if(e === 40) {
        event.preventDefault();

        $(this).parents('li').next().find('a').focus();
      } else if(e === 38) {
        event.preventDefault();
        $(this).parents('li').prev().find('a').focus();
      }  else if (event.shiftKey && e === 9){
        event.preventDefault();
        $('.navigation__list--primary >li:last-child >a').focus();
        $(this).parents('.js-dropdown').removeClass('active');
        $(this).parents('.js-dropdown').find('button').attr("aria-expanded","false");
      } else if (e === 9) {
        event.preventDefault();

        var $nextElementToFocus =  $(this).parents('.js-dropdown').parent().next().find('.js-dropdown >a');

        if($nextElementToFocus.length){
          $nextElementToFocus.focus();
        } else if($('.js-header__search__icon').length){
          $('.header__search__input').focus();
        }

        $(this).parents('.js-dropdown').removeClass('active');
        $(this).parents('.js-dropdown').find('button').attr("aria-expanded","false");

      }
    })

    $('.js-dropdown').on('keydown',function(event){
      if (this.querySelector('.js-dropdown-btn') !== event.target ) return;
      var e = event.which || event.keyCode;

      if(e === 40) {
        event.preventDefault();
        $(this).find('ul >li:first-child> a').focus();
      } else if(e === 38) {
        event.preventDefault();
      } else if (event.shiftKey && e == 9){
        event.preventDefault();
        $('.navigation__list--primary >li:last-child >a').focus();
          $(this).removeClass('active');
          $(this).find('.state__btn').attr("aria-expanded","false");
    } else if( e === 9) {
      event.preventDefault();

      var $nextElementToFocus =  $(this).parent().next().find('.js-dropdown >a');

      if($nextElementToFocus.length){
        $nextElementToFocus.focus();
      }  else if( $('.js-header__search__icon').length){
        $('.header__search__input').focus();
      }
      $(this).removeClass('active');
      $(this).find('.state__btn').attr("aria-expanded","false");
    }
    })




    $(document).on('click', function(e){
      if( !$(e.target).hasClass('state__btn') && $(e.target).parents('.state').length != 1 && $(e.target).parents('.state__btn').length != 1 ){
        $('.state').removeClass('active');

          $(this).find('.state__btn').attr("aria-expanded","false");

      }
      if( !$(e.target).hasClass('btn--login') && $(e.target).parents('.login').length != 1 && $(e.target).parents('.btn--login').length != 1 ){
        $('.login').removeClass('active');
      }
    })



  }
}
